import { render, staticRenderFns } from "./comp-language.vue?vue&type=template&id=46249e18&scoped=true&lang=pug&"
import script from "./comp-language.vue?vue&type=script&lang=js&"
export * from "./comp-language.vue?vue&type=script&lang=js&"
import style0 from "./comp-language.vue?vue&type=style&index=0&id=46249e18&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46249e18",
  null
  
)

export default component.exports